import React, { useState, useEffect, useRef, useContext } from "react";
import { useHistory } from "react-router-dom";
import "./AddMeetUp.css";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import axios from "axios";
import swal from "sweetalert";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { serverInfo } from "../../../../../../App";
import useFileHandleS3 from "../../../../../../CustomHooks/useFileHandleS3";
import MediaUploadProgressBar from "../../../../../../Screen/MediaUploadProgressBar";

const EditMeetUp = (props) => {

  const history = useHistory();
  const [convertedContent, setConvertedContent] = useState("");
  const [instruction, setInstruction] = useState("");
  const [loading, setLoading] = useState(false);
  const { imageCdnUrl } = useContext(serverInfo);


  // File Handle
  const fileInputRef = useRef(null);
  const [filePath, setFilePath] = useState("");
  const [file, setFile] = useState("");
  const [delKey, setDelKey] = useState(null);
  const [fileUrl,fileKey,progress] = useFileHandleS3(file,'meetup/images',delKey);



  const [meetupInput, setMeetup] = useState({
    id: "",
    title: "",
    star_id: "",
    meetup_type: "",
    event_date: "",
    start_time: "",
    end_time: "",
    venue: "",
    total_seat: "",
    reg_start_date: "",
    reg_end_date: "",
    fee: "",
    error_list: [],
  });

  const handleImageChange = (file) => {
    setDelKey(fileKey);
    setFile(file[0]);
  };

  const deleteFile = ()=>
  {
    setFile(null);
    setDelKey(fileKey);
    fileInputRef.current.value = '';

  }

  const handleInput = (e) => {
    e.persist();
    setMeetup({ ...meetupInput, [e.target.name]: e.target.value });
  };

  const meetupSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const fData = new FormData();

    fData.append("banner", fileKey?fileKey:filePath);
    fData.append("title", meetupInput.title);
    fData.append("meetup_type", meetupInput.meetup_type);
    fData.append("event_date", meetupInput.event_date);
    fData.append("start_time", meetupInput.start_time);
    fData.append("end_time", meetupInput.end_time);
    fData.append("description", convertedContent);
    fData.append("instruction", instruction);
    fData.append("venue", meetupInput.venue);
    fData.append("total_seat", meetupInput.total_seat);
    fData.append("reg_start_date", meetupInput.reg_start_date);
    fData.append("reg_end_date", meetupInput.reg_end_date);
    fData.append("fee", meetupInput.fee);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .post(`/api/admin/edit_meetup/${meetupInput.id}`, fData)
        .then((res) => {
          setLoading(false);
          if (res.data.status === 200) {
            if(file){
              setFile('');
              setDelKey(filePath.split("com/").pop())
            }
            swal("Success", res.data.message, "success");
            history.push(
              `/superstar-admin/meetup-events/pending/${res.data.meetup?.id}`
            );
          } else {
            setMeetup({
              ...meetupInput,
              error_list: res.data.validation_errors,
            });
          }
        });
    });
  };

  useEffect(() => {
    const event_id = props.match.params.id;

    axios.get(`/api/admin/meetup_event/details/${event_id}`).then((res) => {
        if (res.data.status === 200) {
          setMeetup(res.data.meetup);
          setConvertedContent(res.data.meetup?.description);
          setInstruction(res.data.meetup?.instruction);
          setFilePath(res.data.meetup?.banner);
        }
      
    });
  }, [props.match.params.slug]);

  return (
    <>
      <div className="card card-bg head-line mb-2">
        <div className="text-light d-flex justify-content-center p-2">
          <div className="faTrophy">
            <i className="fas fa-trophy"></i>
          </div>
          <h4 className="mx-3 text-white px-2 pb-2">Edit Meetup Event</h4>
        </div>
      </div>

      <div className="card card-bg mb-2 p-2 ">
        <div className="card card-bg m-2">
          <div className="container-lg">
            <div className="row">
              <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                <form
                  action=""
                  onSubmit={meetupSubmit}
                  id="input_form"
                  encType="multipart/form-data"
                >
                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Event Name</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        type="text"
                        onChange={handleInput}
                        name="title"
                        value={meetupInput.title}
                      />
                      <small className="text-danger">
                        {meetupInput.error_list?.title}
                      </small>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Description</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <CKEditor
                        name=""
                        data={convertedContent}
                        editor={ClassicEditor}
                        onChange={(event, editor) => {
                          setConvertedContent(editor.getData());
                        }}
                      />
                      <small className="text-danger">
                        {meetupInput.error_list?.description}
                      </small>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Instruction</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <CKEditor
                        name=""
                        data={instruction}
                        editor={ClassicEditor}
                        onChange={(event, editor) => {
                          setInstruction(editor.getData());
                        }}
                      />
                      <small className="text-danger">
                        {meetupInput.error_list?.instruction}
                      </small>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Event Date</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-controlDate"
                        type="date"
                        onChange={handleInput}
                        name="event_date"
                        value={meetupInput.event_date}
                      />
                      <small className="text-danger">
                        {meetupInput.error_list?.event_date}
                      </small>
                    </div>
                  </div>

                  <div className="row ">
                    <div className="col-md-3 my-2 label-text">
                      <p>
                        <>From </>
                      </p>
                    </div>
                    <div className="col-md-3 my-2">
                      <input
                        className="form-control reply-control"
                        type="time"
                        onChange={handleInput}
                        name="start_time"
                        value={meetupInput.start_time}
                      />
                      <small className="text-danger">
                        {meetupInput.error_list?.start_time}
                      </small>
                    </div>

                    <div className="col-md-3 my-2 label-text text-center">
                      <p>
                        <>To </>
                      </p>
                    </div>
                    <div className="col-md-3 my-2">
                      <input
                        className="form-control reply-control"
                        type="time"
                        onChange={handleInput}
                        name="end_time"
                        value={meetupInput.end_time}
                      />
                      <small className="text-danger">
                        {meetupInput.error_list?.end_time}
                      </small>
                    </div>
                  </div>

                  <div className="row ">
                    <div className="col-md-3 my-2 label-text">
                      <p>
                        <>Registration Start</>
                      </p>
                    </div>
                    <div className="col-md-3 my-2">
                      <input
                        className="form-control reply-controlDate"
                        type="date"
                        onChange={handleInput}
                        name="reg_start_date"
                        value={meetupInput.reg_start_date}
                      />
                      <small className="text-danger">
                        {meetupInput.error_list?.reg_start_date}
                      </small>
                    </div>

                    <div className="col-md-3 my-2 label-text text-center">
                      <p>
                        <>To </>
                      </p>
                    </div>
                    <div className="col-md-3 my-2">
                      <input
                        className="form-control reply-controlDate"
                        type="date"
                        onChange={handleInput}
                        name="reg_end_date"
                        value={meetupInput.reg_end_date}
                      />
                      <small className="text-danger">
                        {meetupInput.error_list?.reg_end_date}
                      </small>
                    </div>
                  </div>

                  {meetupInput.meetup_type === "Offline" ? (
                    <div className="row my-4">
                      <div className="col-md-3 label-text">
                        <p>
                          <>Venue</>
                        </p>
                      </div>
                      <div className="col-md-9">
                        <input
                          className="form-control reply-control me-4"
                          type="text"
                          onChange={handleInput}
                          name="venue"
                          value={meetupInput.venue}
                        />
                        <small className="text-danger">
                          {meetupInput.error_list?.venue}
                        </small>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Slots</>
                      </p>
                    </div>
                    <div className="col-md-9">
                      <input
                        className="form-control reply-control"
                        type="number"
                        onChange={handleInput}
                        name="total_seat"
                        value={meetupInput.total_seat}
                        placeholder="120"
                      />
                      <small className="text-danger">
                        {meetupInput.error_list?.total_seat}
                      </small>
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Upload Banner</>
                      </p>
                    </div>
                    <div className="col-md-5">
                      {fileUrl && file? (
                        <div className="position-relative">
                    
                          <img
                          src={fileUrl}
                          className="img-fluid avatar-img-src"
                          alt=""
                          style={{ maxHeight: "300px" }}
                        />  
                       <span className="text-warning right-cross-button" onClick={deleteFile}>X</span>
                        </div>
                      ) : (
                        <img
                          src={imageCdnUrl +                                                                  filePath}
                          className="img-fluid avatar-img-src"
                          alt=""
                          style={{ maxHeight: "300px" }}
                        />
                      )}

                      <input
                        type="file"
                        className="form-control reply-control"
                        onChange={(e) => handleImageChange(e.target.files)}
                        id="image"
                        name="image"
                        accept="image/*"
                        ref={fileInputRef}
                      />
                        {file && !fileUrl && <MediaUploadProgressBar progress={progress} />}
                    </div>
                  </div>

                  <div className="row my-4">
                    <div className="col-md-3 label-text">
                      <p>
                        <>Fee</>
                      </p>
                    </div>
                    <div className="col-md-5">
                      <input
                        className="form-control reply-control"
                        placeholder="120"
                        type="number"
                        onChange={handleInput}
                        name="fee"
                        min={0}
                        value={meetupInput.fee}
                      />
                      <small className="text-danger">
                        {meetupInput.error_list?.fee}
                      </small>
                    </div>
                  </div>

                  {/* Update */}
                  <div className="d-flex justify-content-center aligns-items-center my-4 mt-5">
                    <div className="col-sm-12 col-md-3 col-lg-2">
                      {loading ? (
                        <>
                          <button className="btn btnUpdate">
                            <i className="fas fa-spinner fa-pulse"></i>{" "}
                          </button>
                        </>
                      ) : (
                        <button className="btn btnUpdate fw-bold" type="submit">
                          Update
                        </button>
                      )}
                    </div>
                  </div>
                  {/* Update End */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditMeetUp;
